module.exports = "<ng-template dynamic-template>\n  <ng-content></ng-content>\n</ng-template>"